import React, { useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Alerts from "../../util/Alerts";
import { KPITable } from "./components/KPITable";
import { KPICarouselCards } from "./components/KPICarouselCards";
import { KPIDoughnutSummary } from "./components/KPIDoughnutSummary";
import { queryChartType } from "./schemas/kpi-props.schema";
import { KPIDoughnut } from "./components/KPIDoughnut";
import { KPIBarGraph } from "./components/KPIBarGraph";
import { KPICarouselDoughnut } from "./components/KPICarouselDoughnut";
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { KPIGenderTable } from "./components/KPIGenderTable";
import { StatisticsFilters } from "./components/StatisticsFilters";
import { CubeBasicFilters } from "./schemas/kpi.types";
import { Alert } from "../../interface/alert.interface";

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

export const StatisticsDashboard: React.FC = () => {
    const alertRef = useRef<Alert>();

    const [cubeFilters, setCubeFilters] = useState<CubeBasicFilters>({});

    return (
        <Container>
            <Alerts ref={alertRef} />

            <StatisticsFilters alertRef={alertRef} onFiltersChange={setCubeFilters} />

            {cubeFilters.idClient && cubeFilters.policy && (
                <>
                    <KPICarouselCards cubeFilters={cubeFilters} />

                    <KPITable cubeFilters={cubeFilters} />

                    <KPICarouselDoughnut cubeFilters={cubeFilters} />

                    <Row>
                        <Col lg={6}>
                            <KPIDoughnut
                                cubeFilters={cubeFilters}
                                typeInquiry={queryChartType.TOP_DIAGNOSES}
                                titleChart={"Principales diagnósticos presentados"}
                            />
                        </Col>
                        <Col lg={6}>
                            <KPIDoughnutSummary
                                cubeFilters={cubeFilters}
                                typeInquiry={queryChartType.SEVERITY_FREQUENCY}
                                titleChart={"Severidad vs. Frecuencia"}
                                titleFlag={false}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <KPIGenderTable
                                cubeFilters={cubeFilters}
                                title={"Diagnóstico por género femenino"}
                                gender={"F"}
                            />
                        </Col>
                        <Col>
                            <KPIGenderTable
                                cubeFilters={cubeFilters}
                                title={"Diagnóstico por género masculino"}
                                gender={"M"}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={6}>
                            <KPIBarGraph
                                cubeFilters={cubeFilters}
                                typeAssistance={"Ambulatorio"}
                                titleChart={"Proveedor ambulatorio más utilizado"}
                                groupBy={false}
                            />
                        </Col>
                        <Col lg={6}>
                            <KPIBarGraph
                                cubeFilters={cubeFilters}
                                typeAssistance={"Hospitalario"}
                                titleChart={"Proveedor hospitalario más utilizado"}
                                groupBy={false}
                            />
                        </Col>
                    </Row>

                    <Row className={"mb-4"}>
                        <Col>
                            <KPIBarGraph
                                cubeFilters={cubeFilters}
                                titleChart={"Proveedores más utilizado"}
                                typeAssistance={""}
                                groupBy={true}
                            />
                        </Col>
                    </Row>
                </>
            )}
        </Container>
    );
};
